import { NeutralColor } from "node-library/dist/colors";
import { FrontendTempFilePasswordManagement } from "node-library/dist/portal";
import { useTranslation } from "react-i18next";
import ViewFilePasswordsTable from "./viewFilePasswordsTable";

interface Props {
	filePasswords: Array<FrontendTempFilePasswordManagement>;
	goToViewFileDetails: (file: FrontendTempFilePasswordManagement) => void;
}

export default function TempFilePasswordContent(props: Props) {
	const { t: translation } = useTranslation();

	const { filePasswords, goToViewFileDetails } = props;

	return (
		<div style={{ flex: "1 1 0%", position: "relative" }}>
			{filePasswords.length === 0 ? (
				<div
					style={{
						display: "flex",
						flexDirection: "column",
						alignItems: "center",
						position: "absolute",
						left: "50%",
						top: "50%",
						transform: "translate(-50%, -50%)",
						gap: "5px",
					}}
				>
					<div
						className="typography-heading-01"
						style={{ marginTop: "20px", color: NeutralColor.NEUTRAL_GREY_300 }}
					>
						{translation("NoFiles")}
					</div>
				</div>
			) : (
				<div>
					<ViewFilePasswordsTable
						filePasswords={filePasswords}
						goToViewFileDetails={goToViewFileDetails}
					/>
				</div>
			)}
		</div>
	);
}
